import './App.css';
import Footer from './Components/Footer';
import { NavbarH } from './Components/Navbar';
import RouterComponents from './Components/RouterComponents';
import UserNavbar from './Components/UserNavbar';



function App() {
  return (
  <div className='main'>
  <NavbarH/>
  <UserNavbar/>
  <RouterComponents/>
  <Footer/>
  </div>
  );
}

export default App;
